// extracted by mini-css-extract-plugin
export default {"container":"IG-z","disabled":"JG-z"};